import {
  AccountTree,
  HomeRounded,
  Menu,
  StickyNote2,
} from '@mui/icons-material';
import {
  ClickAwayListener,
  IconButton,
  Paper,
  Popper,
  Stack,
  Tooltip,
} from '@mui/material';
import React from 'react';

import { useDockMenuController } from './index.controller';
import { DockMenuProps } from './index.types';

export function DockMenuView(props: DockMenuProps) {
  const { anchorEl, handleClose, handleOpen, open } =
    useDockMenuController(props);

  // Create an array of the same icon repeated 12 times
  const icons = Array(12)
    .fill(null)
    .map((_, index) => {
      // Cycle through the three icons
      const iconComponents = [HomeRounded, AccountTree, StickyNote2];
      const IconComponent = iconComponents[index % 3];
      return IconComponent;
    });

  return (
    <>
      <Tooltip title="Menu" placement="top">
        <IconButton
          onClick={handleOpen}
          sx={{
            color: 'white',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
          }}
        >
          <Menu />
        </IconButton>
      </Tooltip>
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="top"
        sx={{ zIndex: 1300 }}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Paper elevation={8}>
            <Stack width={300} direction="row" flexWrap="wrap">
              {icons.map((IconComponent, index) => (
                <Stack key={index}>
                  <IconButton
                    onClick={handleClose}
                    sx={{
                      p: 2,
                    }}
                  >
                    <IconComponent />
                  </IconButton>
                </Stack>
              ))}
            </Stack>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  );
}
